export interface RiskAiDetection {
  messageId: string;
  internetMessageId: string;
  action: string;
  timestamp: string;
  msgFrom: string;
  msgSubject: string;
  mailbox: string; // recipient
  matchedFilters: string[]; // flatten filter names for each rule of raiMatchedRules
  matchedFilterIds: string[]; // flatten filter names for each rule of raiMatchedRules
  threatType: string; // constructed from original threatType and raiMatchedRules' threat_type field
  raiRiskType: RiskAiRiskType;
  securityRiskName: string; // constructed from raiMatchedRules
  securityRiskId: string;
  traceId: string;
  companyGuid: string;
  scanSource: 'Exchange Online' | 'Gmail' | 'Exchange Inline' | 'Gmail Inline';
  detectedBy?: string; // Detected by: Agentic AI module, Custom Correlated Intelligence, or Correlated Intelligence (translated for display)
  malwareDetectedBy?: string; // Backend value of detectedBy (malwareDetectedBy field from API)
  raiLLMThreatAnalysis?: {
    summary?: string;
    most_suspicious_items?: string[];
  };
}

export enum RiskAiRiskType {
  SecurityRisk = 'Security Risk',
  Anomaly = 'Anomaly',
  CustomizedAnomaly = 'Custom Correlated Intelligence',
}

export type SortOrder = 'asc' | 'desc';
